var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTemplate = function SvgTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_template",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icn_template-2",
    "data-name": "icn_template",
    d: "M-3054.163,188.02a1.364,1.364,0,0,1-1.36-1.372v-10.1a1.363,1.363,0,0,1,1.36-1.366h9.018a1.368,1.368,0,0,1,1.367,1.366v10.1a1.369,1.369,0,0,1-1.367,1.372Zm-.193-11.476v10.1a.2.2,0,0,0,.193.2h9.018a.2.2,0,0,0,.2-.2v-10.1a.2.2,0,0,0-.2-.2h-9.018A.2.2,0,0,0-3054.356,176.543Zm1.828,8.47v-1.168h5.253v1.168Zm-5.055-2.312a1.368,1.368,0,0,1-1.366-1.366v-7.951a1.368,1.368,0,0,1,1.366-1.366h10.11a1.368,1.368,0,0,1,1.366,1.366v.625h-1.167v-.625a.2.2,0,0,0-.2-.2h-10.11a.2.2,0,0,0-.2.2v7.951a.2.2,0,0,0,.2.2h.893V182.7Zm5.055-.584v-1.167h5.253v1.167Zm0-2.358v-1.168h5.253v1.168Z",
    transform: "translate(3080.364 -82.02)",
    fill: "#8d8d8d",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template.f16a533c.svg";
export { ForwardRef as ReactComponent };